@if (label()) {
  <div class="table-label" [dojoRichText]="label()"></div>
}
<table class="data-table">
  @if (showHeader()) {
    <thead>
      <tr class="header-row">
        @for (col of columns(); track col.key) {
          <th [style.text-align]="getAlignment(col)" [dojoRichText]="col.header"></th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (row of rows(); track $index) {
      <tr
        class="data-row"
        [class.hovered]="hoveredRowIndex() === $index"
        [class.hoverable]="row.onHover"
        (mouseenter)="onRowMouseEnter(row, $index)"
        (mouseleave)="onRowMouseLeave(row, $index)"
      >
        @for (col of columns(); track col.key) {
          <td
            [style.text-align]="getAlignment(col)"
            [dojoRichText]="row.values[col.key]"
            [richTextResolve]="resolveValue()"
          ></td>
        }
      </tr>
    }
  </tbody>
</table>
